<template>
  <el-menu
    :default-active="active"
    class="el-menu-demo"
    mode="horizontal"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#409EFF"
    router
  >
    <el-menu-item v-for="item in tabs" :key="item.index" :index="item.index">{{
      item.label
    }}</el-menu-item>
  </el-menu>
</template>
<script>
export default {
  name: "HeaderTabs",
  props: ["active"],
  data() {
    return {
      tabs: [
        {
          index: "/home/wavepicking/wavepickingsetting",
          label: "仓库基本配置",
        },
        {
          index: "/home/wavepicking/wavepickingsender",
          label: "寄件地址配置",
        },
        {
          index: "/home/wavepicking/labelusersetting",
          label: "改标用户汇总配置",
        },
        {
          index: "/home/wavepicking/labeluserspace",
          label: "改标用户列表",
        },
        {
          index: "/home/wavepicking/weighturnsetting",
          label: "称重转向配置",
        },
        {
          index: "/home/wavepicking/mallshippingarea",
          label: "地区可用快递设置",
        },
        {
          index: "/home/wavepicking/mallshippingopen",
          label: "用户可选快递设置",
        },
        {
          index: "/home/wavepicking/alertLock",
          label: "PC点货/拆包设置",
        },
        {
          index: "/home/wavepicking/onlydabiaosetting",
          label: "PC点货分离设置",
        },
        { index: "/home/wavepicking/dabiaosetting", label: "点货配置" },
        {
          index: "/home/wavepicking/stockdetailseparatesetting",
          label: "点货库存分离配置",
        },
        {
          index: "/home/wavepicking/gridsetting",
          label: "分播机格口设置",
        },
        {
          index: "/home/adminsetting/qualitylabelsetting",
          label: "质检改标配置",
        },
        {
          index: "/home/wavepicking/checksetting",
          label: "波次校验设置",
        },
        { index: "/home/wavepicking/pdasetting", label: "Pda配置" },
        {
          index: "/home/wavepicking/cutsetting",
          label: "波次分播设置",
        },
        {
          index: "/home/logistics/logisticslist",
          label: "物流管理配置",
        },
        { index: "/home/gaibiao/gbtypesetting", label: "改标类型管理" },
        { index: "/home/gaibiao/gbusersetting", label: "改标人员管理" },
        { index: "/home/setting/expresssize", label: "快递模板管理" },
        { index: "/home/setting/upshelf", label: "上架设置" },
        {
          index: "/home/setting/TallyTaskSetting",
          label: "理货任务生成规则",
        },
        {
          index: "/home/setting/supplypackagetips",
          label: "仓库收包商家提示",
        },
        {
          index: "/home/setting/surpass_vip_user",
          label: "VIP用户列表",
        },
        {
          index: "/home/setting/goods_integration",
          label: "货位整合配置",
        },
        { index: "/home/setting/script_setting", label: "脚本配置" },
        {
          index: "/home/setting/take_stock_tip",
          label: "PC点货提示配置",
        },
        {
          index: "/home/setting/quality_inspection_rule_setting",
          label: "质检规则配置",
        },
        {
          index: "/home/setting/express_account",
          label: "快递账号配置",
        },
        {
          index: "/home/setting/return_task_priority",
          label: "退供配置",
        },
        {
          index: "/home/setting/push_setting",
          label: "推送配置",
        },
        {
          index: "/home/setting/express-optimization-setting",
          label: "使用快递优选地区设置",
        },
        {
          index: "/home/setting/warehouse-transfer-setting",
          label: "跨仓调拨设置",
        },
        {
          index: "/home/setting/tomorrow-transport-setting",
          label: "次日发货设置",
        },
        {
          index: "/home/setting/defective-category-list",
          label: "质检次品类型",
        },
        {
          index: "/home/setting/sold-out",
          label: "售后配置",
        },
        {
          index: "/home/setting/warehouse-purchase-setting",
          label: "仓采配置",
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wavepicking/components/HeaderTabs.vue